import { Link } from "react-router-dom";
import { useTranslation } from "../i18n/LanguageContext";
import logoSrc from "../assets/logo-rava.png";

export default function Footer() {
  const year = new Date().getFullYear();
  const t = useTranslation();

  return (
    <footer className="bg-navy">
      <div className="max-w-content mx-auto px-6 md:px-12 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8 text-footer-text">
          <div>
            <Link to="/" className="inline-block mb-5 bg-white p-2">
              <img src={logoSrc} alt="RAVA" className="h-16" />
            </Link>
            <p className="text-sm leading-relaxed mb-2">{t.footer_tagline}</p>
            <p className="text-sm opacity-50">{t.footer_location}</p>
          </div>

          <div>
            <h4 className="text-[12px] uppercase tracking-[0.1em] font-semibold text-white mb-6">{t.footer_nav}</h4>
            <ul className="space-y-3">
              {[
                { label: t.nav_home, to: "/" },
                { label: t.nav_about, to: "/a-propos" },
                { label: t.nav_services, to: "/services" },
                { label: t.nav_projects, to: "/realisations" },
                { label: t.nav_contact, to: "/contact" },
              ].map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm hover:text-white transition-colors duration-300">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-[12px] uppercase tracking-[0.1em] font-semibold text-white mb-6">{t.footer_services}</h4>
            <ul className="space-y-3">
              {[
                { label: t.svc_construction_title, to: "/services/construction" },
                { label: t.svc_tp_title, to: "/services/travaux-publics" },
                { label: t.svc_logistique_title, to: "/services/logistique" },
                { label: t.svc_sst_title, to: "/services/sst" },
                { label: t.svc_digital_title, to: "/services/digital" },
              ].map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm hover:text-white transition-colors duration-300">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-[12px] uppercase tracking-[0.1em] font-semibold text-white mb-6">{t.footer_contact}</h4>
            <div className="space-y-3 text-sm">
              <p>08, av. Savonnier, Bel-Air<br />Kampemba, Lubumbashi, RDC</p>
              <p>+(243) 993 800 679</p>
              <p>+1 (438) 227-0788</p>
              <p>contact@ravaservices.net</p>
            </div>
          </div>
        </div>

        <div className="border-t border-navy-light mt-16 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-[13px] text-footer-text opacity-60">
          <span>{year} {t.footer_rights}</span>
          <div className="flex gap-8">
            <span>RCCM : CD/LSH/RCCM/24-B-01387</span>
            <span>NIF : A2426094Q</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
